export default "/images/f498e22449db759aa536d9712799f64a.avif";